import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import { Row, Col } from "react-flexbox-grid";
import SeekerStore from "../../../stores/seekerStore";
import  EducationStore from "../../../stores/educationsStore";
import { CourseOffering } from "../../../models/education";
import { ILocalization } from "../../../models/localization";
import { ScreenMode } from "../../../models/enums";
import OpportunityStore from "../../../stores/opportunityStore";
import NavigateNext from "material-ui-icons/NavigateNext";
import NavigateBefore from "material-ui-icons/NavigateBefore";
import Slider from "react-slick";
import Button from "material-ui/Button";
import * as s from "./educationSlider.css";

interface IParams {
  opId: string;
}

@observer
export class Education extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _edStore: EducationStore;
  private _opStore: OpportunityStore;
  private slider: any;
  constructor(props: any) {
    super(props);
    this._edStore = this.props.store.educationStore;
    this._opStore = this.props.store.opportunityStore;
    this.slider = null;
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  renderContent(content: Array<CourseOffering>, cls: string): JSX.Element[] {
    const local: ILocalization = this.props.store.localization.fields;
    const items: JSX.Element[] = [];
    content.map((co: CourseOffering, i: number): void => {
      const descriptionUrl = co.descriptionUrl || '#';
      const registerUrl = co.registrationUrl || '#';
      items.push(<div key={i}>
        <div className={cls}>
          <br />
          <h5 className={s.courseName}>{co.title}{co.isOnline && <span className={s.online}>{local.addEducation.online}</span>}</h5>
          <p className={s.description}>{co.description}</p>
          {co.institution["name"] && <p className={s.courseInstitute}>{co.institution["name"]}</p>}
          <Row>
            {co.descriptionUrl && <Col xs={6}><a target="_blank" onClick={() => { this.props.store.viewState.showLink(descriptionUrl); }} ><p className={s.learnMore}>{local.learnMore}</p></a></Col>}
            {co.registrationUrl && <Col xs={6}><a target="_blank" onClick={() => { this.props.store.viewState.showLink(registerUrl); }} ><p className={s.learnMore}>{local.availCourses.register}</p></a></Col>}
          </Row>
        </div></div>);
    });
    return items;
  }

  renderHorizontalSlider(): JSX.Element {
    const co: Array<CourseOffering> = this.props.store.educationStore.courses;
    const local: ILocalization = this.props.store.localization.fields;
    const settings: any = {
      slidesToShow: 1,
      dots: false,
      infinite: true,
      centerPadding: 0,
      autoplay: false,
      slidesToScroll: 1,
      adaptiveHeight: true,
      swipe: true    
    }

    return (<div>
      <Row>
        <Col xsOffset={1} xs={10} smOffset={2} sm={8} >
          <h4 className={s.header}>{local.opportunity.educationHeader}</h4>
        </Col>
      </Row>
      <Slider
      nextArrow={<CustomNextArrow />}
      prevArrow={<CustomPrevArrow />}
      {...settings}>
      {this.renderContent(co, s.slickSlideStyle)}
    </Slider></div>)
  }

  renderVerticalSlider(): JSX.Element {
    const co: Array<CourseOffering> = this.props.store.educationStore.courses;
    const settings: any = {
      slidesToShow: 3,
      draggable: true,
      vertical: true,
      infinite: true,
      centerMode: true,
      centerPadding: 0,
      slidesToScroll: 1,
      swipe: true,
      arrows: false,
    }

    return (<div><Slider ref={(c) => { this.slider = c; }} {...settings}>
      {this.renderContent(co, s.slickSlideVertical)}   
    </Slider></div> )
  }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const local: ILocalization = this.props.store.localization.fields;
    const btnStyle: any = {
      margin: "4px",
      position: "relative",
      top: "50%",
      transform: "translateY(-50%)",
      padding: 0
    }
    return (<div>
      {mode === ScreenMode.Desktop && this._opStore.selectedOp && <Row>
        <Col xs={12} className={s.sliderCol}>{this.renderVerticalSlider()}</Col>
        <Col xs={12} className={s.btnCol}>
          <Button raised style={btnStyle} onClick={this.previous} color="secondary"><NavigateBefore />&nbsp;{local.previous}&nbsp;&nbsp;</Button>
          <Button raised style={btnStyle} onClick={this.next} color="secondary">&nbsp;&nbsp;{local.next}&nbsp;<NavigateNext /></Button>
        </Col>
      </Row>}
      {mode !== ScreenMode.Desktop && this._opStore.selectedOp && this.renderHorizontalSlider()}
      </div>)
  }
}

function CustomNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.slickArrowNext}
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        top: '50%',
        background: '#0000004a',
        height: '100%',
        width: '24px',
        right: '3px',
        transform: 'translateY(-50%)',
        zIndex: '1'
      }}
      onClick={onClick}
    ></div>
  );
}

function CustomPrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={s.slickArrowPrev}
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        top: '50%',
        background: '#0000004a',
        height: '100%',
        width: '24px',
        left: '3px',
        transform: 'translateY(-50%)',
        zIndex: '1'
      }}
      onClick={onClick}
    ></div>
  );
}


// WEBPACK FOOTER //
// ./src/components/opportunity/educationSlider/index.tsx